import React, {useState} from 'react';
import {Linking, Text, TouchableOpacity, View} from 'react-native';
import {WebView} from 'react-native-webview';
import {useSelector} from 'react-redux';
import {useUserId} from 'src/Hooks/reduxHooks';
import {BodyText} from 'src/Modules/CommonView';

import useWindowDimensionsSafe from 'src/Modules/Native/useWindowDimensionsSafe';

import FastImage from '../../Utils/FastImage';

import Icon from 'react-native-vector-icons/FontAwesome';

import {applyReviewBonusPoints} from 'src/Utils/huntFunctions';

import {navigationRef} from 'src/Nav/navigationHelpers';
import {apiMarkSocialCompleted} from 'src/Utils/apiCalls';
import CustomActivityIndicator from '../../Modules/CommonView/CustomActivityIndicator';

const SocialReviewItem = ({
  reviewLink,
  reviewTitle,
  reviewMessage,
  reviewType,
  reviewIcon,
  reviewLetter,
  reviewText,
  reviewColor,
  points,
  showReviewItem,
  embedded,
}) => {
  const {width} = useWindowDimensionsSafe();

  const userId = useUserId();
  const groupInfo = useSelector((state) => state.groupInfo);

  const [showVerify, setShowVerify] = useState(false);
  const [isValidating, setIsValidating] = useState(false);
  const [hasReview, setHasReview] = useState(false);
  const [showContinue, setShowContinue] = useState(false);

  const handleReviewPress = () => {
    if (reviewTitle && reviewMessage) {
      navigationRef.navigate('ConfirmModal', {
        handleConfirm: async () => {
          navigationRef.goBack(null);
          Linking?.openURL(reviewLink);
          if (!hasReview) {
            setShowVerify(true);
          }
        },
        confirmText: 'Leave A Review',
        cancelText: 'Cancel',
        confirmColor: global?.color?.orange,
        titleText: reviewTitle,
        titleBodyText: reviewMessage,
      });
    } else {
      Linking?.openURL(reviewLink);
      if (!hasReview) {
        setShowVerify(true);
      }
    }
  };

  const handleReviewVerifyPress = () => {
    applyReviewBonusPoints(reviewType, 300, groupInfo, userId);
    apiMarkSocialCompleted(userId, reviewType);
    setHasReview(true);
  };

  const handleNavigationStateChange = async (event) => {
    console.log('the event is ', event);
    if (event?.url?.includes?.('tripadvisor')) {
      let openinningURL = event.url;
      if (openinningURL == 'https://www.tripadvisor.com/') {
        openinningURL = reviewLink + '?force_open=true';
      }

      Linking?.openURL(openinningURL);
      setIsValidating(true);
      setTimeout(() => {
        setIsValidating(false);
        setShowContinue(true);

        applyReviewBonusPoints(reviewType, 300, groupInfo, userId);
        apiMarkSocialCompleted(userId, reviewType);
      }, 1500);
    }
    // Alert.alert('hi');
  };

  if (!showReviewItem) {
    return <View />;
  }
  if (embedded && !isValidating && !showContinue) {
    return (
      <View style={{width: width - 20, height: 600}}>
        {!!__DEV__ && <Text>Dev: {reviewLink}</Text>}
        <WebView
          style={{flex: 1, backgroundColor: 'black', height: 600}}
          scalesPageToFit={false}
          bounces={false}
          source={{uri: reviewLink}}
          onNavigationStateChange={(event) => {
            console.log({event});
            handleNavigationStateChange(event);
          }}
        />
      </View>
    );
  }

  return (
    <View
      style={{
        justifyContent: 'center',
        alignItems: 'center',
        marginTop: embedded ? 30 : 0,
      }}>
      <View
        style={{
          height: 1,
          width: 100,
          backgroundColor: 'black',
        }}
      />
      {!embedded && (
        <TouchableOpacity
          style={{
            backgroundColor: reviewColor,
            height: 80,
            marginVertical: 5,
            marginHorizontal: 10,
            width: width - 20,
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'space-between',
          }}
          onPress={() => handleReviewPress()}>
          {!!reviewIcon && (
            <FastImage
              style={{
                width: 30,
                height: 25,
                marginLeft: 10,
              }}
              source={reviewIcon}
              resizeMode={FastImage?.resizeMode?.contain}
            />
          )}
          {!!reviewLetter && (
            <Text
              style={{
                // width: 30,
                // height: 25,
                marginLeft: 10,
                color: 'white',
                fontWeight: '700',
                fontSize: 35,
              }}
              source={reviewIcon}
              resizeMode={FastImage?.resizeMode?.contain}>
              {reviewLetter}
            </Text>
          )}
          <BodyText
            text={reviewText}
            textStyle={{
              color: global?.color?.white,
              fontSize: 16,
              width: 200,
              textAlign: 'center',
              marginTop: 5,
            }}
          />
          <View
            style={{
              backgroundColor: global?.color?.white1,
              width: 90,
              height: 80,
              justifyContent: 'center',
              alignItems: 'center',
            }}>
            <Icon name={'pencil'} size={24} color={global?.color?.gray3} />
            <BodyText
              text={`+ ${points} pts`}
              textStyle={{fontSize: 14, marginTop: 5}}
            />
          </View>
        </TouchableOpacity>
      )}
      {!!showVerify && !hasReview && (
        <TouchableOpacity
          style={{
            backgroundColor: global?.color?.orange,
            height: 40,
            marginVertical: 10,
            width: width - 100,
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'center',
          }}
          onPress={() => handleReviewVerifyPress()}>
          {!!isValidating ? (
            <View
              style={{
                width: 200,
                justifyContent: 'center',
                alignItems: 'center',
              }}>
              <CustomActivityIndicator size={'small'} color={'white'} />
            </View>
          ) : (
            <Text
              style={{
                color: 'white',
                fontSize: 20,
                width: 220,
                fontFamily: 'Alternate Gothic No3 D',
                textAlign: 'center',
                justifyContent: 'center',
                alignItems: 'center',
              }}>
              {!!showContinue
                ? 'CONTINUE'
                : hasReview
                ? 'Points Awarded'
                : 'VERIFY YOUR ACTION'}
            </Text>
          )}
        </TouchableOpacity>
      )}
      {(!!showContinue || !!showVerify || !!hasReview) && (
        <Text
          style={{
            color: global?.color?.gray3,
            fontSize: 14,
            width: 280,
            paddingLeft: embedded ? 100 : 0,
            paddingTop: embedded ? 50 : 0,
            fontFamily: global?.font.circular,
            textAlign: 'center',
            justifyContent: 'center',
            alignItems: 'center',
            marginBottom: 10,
          }}>
          {!!showContinue
            ? `Thanks for the review! You earned ${points} bonus points`
            : showVerify
            ? hasReview
              ? `Thanks for the review! You earned ${points} bonus points!`
              : 'It can take up to 1 minute after you post for our system to find the review.'
            : ''}
        </Text>
      )}
    </View>
  );
};

export default SocialReviewItem;
